import { Swiper, SwiperSlide } from 'swiper/react';
import './productsIndex.less';
import 'swiper/css';

// ----------- 公共 WearableProductSection 组件 -----------
/** 
 * 受控参数:
 * - active 是否是当前页
 * - config: { name, subtitle, link, mainImage, images, colorOptions, borderStyles, switchColor, currentColor, groupImages, currentImage, nextImage }
 * - ...其余与状态控制相关的数据
 **/
const WearableProductSection = ({
  isActive,
  hovered,
  setHovered,
  navigate,
  config,
  transitionDirection = '',
  isTransitioning = false,
  isSwitching = false,
  swiperKey,
  displayedImages = [],
  nextImages = [],
  currentImage,
  nextImage, // 下一个主图/仅Argos, EyePal需要
  onSwitchColor, // 切换颜色函数
  currentColor,
  borderStyles,
  mobileMainImage,
  images, // ARTA级
}) => {
  const isColorful = config?.colorOptions?.length > 1;
  const showNextImage = !!nextImage && !!transitionDirection;
  const groupImages = images || displayedImages;

  // PC端“主图支持动画”  
  const renderMainImage = () => {
    return (
      <div className={`Argos_productImg flex_row flex_jc-fe flex_ai-c ${isActive ? 'active' : ''}`}>
        <img
          className={`Argos_productImg-img ${transitionDirection ? 'slide-out' : ''}`}
          style={{ width: config.mainImageWidth || '64%', maxWidth: '1405px' }}
          src={currentImage || config.mainImage}
          alt=""
        />
        {//nextImage形式仅ARGOS/EYEPAL有
          showNextImage && (
            <img
              className={`Argos_productImg-img slide-in`}
              style={{ width: config.mainImageWidth || '64%', maxWidth: '1405px' }}
              src={nextImage}
              alt=""
            />
          )
        }
      </div>
    );
  };

  // 移动端主图，仅ARGOS/EYEPAL可动画
  const renderMobileImage = () => (
    <div className={`Argos_productImg-mobile ${isActive ? 'active' : ''}`}>
      <img
        className={`Argos_productImg-mobileImg ${transitionDirection ? 'slide-out' : ''}`}
        style={{ width: '100%' }}
        src={currentImage || mobileMainImage || config.mobileMainImage || config.mainImage}
        alt=""
      />
      {showNextImage && (
        <img
          className={`Argos_productImg-img slide-in`}
          style={{ width: '100%' }}
          src={nextImage}
          alt=""
        />
      )}
    </div>
  );

  // PC端/移动端底部小图组
  const renderImagesGroup = () => (
    <>
      {/* PC端图片组 */}
      <div className="Argos_bottom-img of_hidden">
        {groupImages && groupImages.map((url, idx) => (
          <img
            key={`current-${idx}`}
            className={`Argos_bottom-imgItem ${isActive ? 'active' : ''} ${isTransitioning ? 'slide-out' : ''}`}
            src={url}
            alt=""
            style={{
              transitionDelay: isSwitching
                ? `${0.2 * idx}s`
                : `${0.2 * idx + 1}s`
            }}
          />
        ))}
        {/* 下一组即将显示的图片（仅Argos/Eyepal彩色版支持） */}
        {nextImages && nextImages.map((url, idx) => (
          <img
            key={`next-${idx}`}
            className={`Argos_bottom-imgItem slide-in`}
            src={url}
            alt=""
            style={{ transitionDelay: `${0.2 * idx}s` }}
          />
        ))}
      </div>
      {/* 移动端组图Swiper */}
      <Swiper
        key={swiperKey}
        slidesPerView={'auto'}
        centeredSlides={true}
        className="Products_swiper"
      >
        {(groupImages || []).map((url, idx) => (
          <SwiperSlide key={idx}>
            <img
              className={`Argos_bottom-imgItem ${isActive ? 'active' : ''} ${isTransitioning ? 'slide-out' : ''}`}
              src={url}
              alt=""
              style={{
                transitionDelay: isSwitching
                  ? `${0.2 * idx}s`
                  : `${0.2 * idx + 1}s`
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );

  // Color切换按钮（仅存在于需要色切的产品）
  const renderColorSwitch = () =>
    isColorful && (
      <div className={`Argos_bottom ${isActive ? 'active' : ''}`}>
        {config.colorOptions.map(({ color, btnClass, borderStyle }, idx) => (
          <div
            key={color}
            className={btnClass}
            style={currentColor === color ? borderStyle : {}}
            onClick={() => onSwitchColor && onSwitchColor(color)}
          />
        ))}
      </div>
    );

  // Brief信息区域（顶部）
  const renderBrief = () => (
    <div className='Argos_top pageMargin'>
      <div className='of_hidden'>
        {/* PC端 */}
        <div className={`Argos_topBlockPc flex_row flex_jc-sb ${isActive ? 'active' : ''}`}>
          <div className='linear-gradient-tr fz_32 fw_700 lh_38'>集视穿戴产品</div>
          <div className='fz_20 fw_500 lh_24 linear-gradient-tr'>Focusight®<br />Wearable products</div>
          <div className='fz_16 fw_500 lh_24 c_85899E'>
            集视医疗致力于融合底层脑科学+眼病机制研究+可穿戴智能化产品，<br />
            有效改善了传统弱视干预手段在年龄、效果、治疗场景、患者依从性等方面的局限。
          </div>
        </div>
        {/* 移动端 */}
        <div className='Argos_topBlockMobile'>
          <div className={`Argos_topMobile flex_row flex_jc-sb ${isActive ? 'active' : ''}`}>
            <div>
              <div className='fz_18 fw_700 lh_21 linear-gradient-tr'>集视穿戴产品</div>
              <div className='fz_14 fw_500 lh_16 mt_6 linear-gradient-tr'>Focusight®<br />Wearable products</div>
            </div>
            <div
              className='Wearable_product-mobileBtn flex_row flex_jc-c flex_ai-c'
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
              onClick={() => navigate(config.link)}
            >
              <div>了解产品</div>
              <img
                className='Wearable_product-rightArrowMobile'
                src={hovered ? './images/home/arrow-right-whiteLine.png' : './images/home/arrow-right-blackLine.png'}
                alt=''
              />
            </div>
          </div>
          <div
            className={`Argos_product mt_40 c_23253B ta_c ${isActive ? 'active' : ''}`}>
            <div className="fz_24 fw_900 lh_28">{config.name}</div>
            <div className="fz_14 fw_500 lh_16 mt_2">{config.subtitle}</div>
          </div>
        </div>
      </div>
    </div>
  );

  // PC副标题区/按钮
  const renderProductInfo = () => (
    <div className='pageMargin'>
      <div className={`Argos_product btn_display ${isActive ? 'active' : ''}`}>
        <div className={config.titleClass || "Argos_product-title"}>{config.name}</div>
        <div className={config.subTitleClass || "Argos_product-subTitle"}>{config.subtitle}</div>
        <div
          className='Wearable_product-btn flex_row flex_jc-c flex_ai-c'
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          onClick={() => navigate(config.link)}
        >
          <div>了解产品</div>
          <img
            className='Wearable_product-rightArrow'
            src={hovered ? './images/home/arrow-right-whiteLine.png' : './images/home/arrow-right-blackLine.png'}
            alt=''
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className='Argos'>
      {renderMainImage()}
      <div
        className='of_hidden flex_col flex_jc-sb gap_16'
        style={{ minHeight: '100vh' }}
      >
        {renderBrief()}
        <div>
          {renderProductInfo()}
          {renderMobileImage()}
        </div>
        <div className='pageMargin'>
          {renderColorSwitch()}
          {renderImagesGroup()}
        </div>
      </div>
    </div>
  );
};

export default WearableProductSection;